import { StoreAdminUsersState, AdminUser } from '@/types';

export const SET_ADMIN_USERS = 'SET_ADMIN_USERS';

export default {
  [SET_ADMIN_USERS]: (state: StoreAdminUsersState, payload: AdminUser[]): void => {
    state.adminUsers = payload;
  },
};
